/**
 * Mobile Sticky ATC Bar
 * File: assets/mobile-sticky-atc.js
 *
 * How it works:
 * - Listens to <select> changes
 * - Finds the matching Shopify variant from all selections
 * - Writes that variant ID into Broadcast's hidden input[name="id"]
 * - Submits via the existing Broadcast product form
 * - Price + availability updates live as customer changes dropdowns
 */
(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const bar = document.getElementById('mobile-atc-bar');
    if (!bar) return;

    const productId = bar.dataset.productId;
    const formId    = bar.dataset.formId;

    const variantsEl = document.getElementById('mobile-atc-variants-' + productId);
    const configEl   = document.getElementById('mobile-atc-options-'  + productId);
    if (!variantsEl || !configEl) return;

    let variants, config;
    try {
      variants = JSON.parse(variantsEl.textContent);
      config   = JSON.parse(configEl.textContent);
    } catch (e) {
      console.warn('[mobile-atc] JSON parse error', e);
      return;
    }

    // ── DOM refs ──
    const selects   = bar.querySelectorAll('.mobile-atc-bar__select');
    const submitBtn = bar.querySelector('[data-atc-submit]');

    // Broadcast's hidden variant ID input — bridge to their form
    const variantInput = (
      document.querySelector('input[name="id"][form="' + formId + '"]') ||
      document.querySelector('#' + CSS.escape(formId) + ' input[name="id"]') ||
      document.querySelector('form[id="' + formId + '"] input[name="id"]')
    );

    // ── Pre-select first available variant in all dropdowns ──
    const firstAvailable = variants.find(v => v.available) || variants[0];
    if (firstAvailable) {
      selects.forEach(function (select) {
        const idx = parseInt(select.dataset.optionIndex, 10);
        const val = ['option1', 'option2', 'option3'][idx];
        if (firstAvailable[val]) {
          select.value = firstAvailable[val];
        }
      });
    }

    // ── Listen to dropdown changes ──
    selects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });

    // ── Match current dropdown selections to a variant ──
    function getSelectedOptions() {
      const opts = {};
      selects.forEach(function (select) {
        const idx = parseInt(select.dataset.optionIndex, 10);
        opts[idx] = select.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        if (opts[0] !== undefined && opts[0] !== '' && v.option1 !== opts[0]) return false;
        if (opts[1] !== undefined && opts[1] !== '' && v.option2 !== opts[1]) return false;
        if (opts[2] !== undefined && opts[2] !== '' && v.option3 !== opts[2]) return false;
        return true;
      }) || null;
    }

    // ── Update everything when a dropdown changes ──
    function updateVariant() {
      const opts    = getSelectedOptions();
      const variant = findVariant(opts);
      const available = variant ? variant.available : false;
      const price     = variant ? variant.price     : null;

      // Write variant ID into Broadcast's form
      if (variantInput && variant) {
        variantInput.value = variant.id;
        // Fire change event so Broadcast's own JS stays in sync
        // (updates main page price, images, etc.)
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update button text + price
      const soldOutText  = 'Sold Out';
      const addCartText  = 'Add to Cart';
      const btnText      = bar.querySelector('[data-atc-btn-text]');
      const btnPrice     = bar.querySelector('[data-atc-btn-price]');
      const btnSep       = bar.querySelector('.mobile-atc-bar__btn-sep');

      if (btnText) btnText.textContent = available ? addCartText : soldOutText;

      if (price !== null && available) {
        if (btnPrice) btnPrice.textContent = formatMoney(price);
        if (btnSep)   btnSep.style.display = '';
        if (btnPrice) btnPrice.style.display = '';
      } else {
        // Hide price when sold out — just show "Sold Out"
        if (btnSep)   btnSep.style.display = 'none';
        if (btnPrice) btnPrice.style.display = 'none';
      }

      // Enable/disable submit
      if (submitBtn) submitBtn.disabled = !available;
    }

    // ── Format money ──
    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        const fmt = config.moneyFormat || (window.theme && window.theme.moneyFormat) || '{{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      }
      return 'RM ' + (cents / 100).toFixed(2);
    }

    // ── Loading state on submit ──
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (submitBtn.disabled) return;
        submitBtn.classList.add('is-loading');
        const done = function () {
          submitBtn.classList.remove('is-loading');
        };
        document.addEventListener('cart:item-added', done, { once: true });
        setTimeout(done, 4000); // fallback
      });
    }

    // ── Hide bar when native ATC button is visible on screen ──
    // Finds Broadcast's real ATC button — hides our bar while it's in view
    const nativeBtn = document.querySelector(
      '.product__submit__add, [data-add-to-cart], .btn--add-to-cart, [data-cart-bar-scroll]'
    );

    if (nativeBtn && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-native-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(nativeBtn);
    }

    // ── Init sync ──
    updateVariant();
  }

})();